import Select, { components } from "react-select";
import styles from "./index.module.scss";
import ProfilePreview from "../ProfilePreview";
import { UserType } from "../../../types/userType";

type PropsType = {
  options;
  user: UserType;
};

// -- Custom Components & Styles for react-styles --
const { Option, Control } = components;

const IconOption = (props) => (
  <Option {...props}>
    <button
      type="button"
      className={styles.optionButton}
      onClick={props.data.onClick}
    >
      {props.data.label}
    </button>
  </Option>
);

let isOpen = false;

const customStyles = {
  control: (provided, state) => {
    isOpen = state.menuIsOpen;
    return {
      ...provided,
      width: "250px",
      padding: "8px",
      border: "0",
      borderRadius: "4px",
      boxShadow: state.menuIsOpen ? `0px 1px 3px ${styles.box_shadow}` : "none",
      "&:hover": {
        boxShadow: `0px 1px 3px ${styles.box_shadow}`,
      },
    };
  },
  dropdownIndicator: (provided) => ({
    ...provided,
    color: styles.black,
    transition: "transform 100ms ease-in-out",
    transform: isOpen ? "rotate(180deg)" : "",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: "16px",
    lineHeight: "24px",
    padding: "0px",
    color: styles.black,
    width: "100%",
    height: "40px",
    border: state.isFocused
      ? `1px solid ${styles.grey_200}`
      : "1px solid transparent",
    background: state.isFocused ? styles.grey_100 : "transparent",

    "&:active": {
      background: styles.grey_200,
    },
  }),
  menu: (provided) => ({
    ...provided,
    width: "250px",
    boxShadow: `0px 1px 3px ${styles.box_shadow}`,
    borderRadius: "4px",
  }),
};

const ProfileDropdown = ({ options, user }: PropsType) => {
  const IconControl = (props) => (
    <Control {...props}>
      <div className={styles.controlGrid}>
        <div>
          <ProfilePreview size="medium" user={user} userRole />
        </div>
        <div>
          <div style={{ opacity: 0, width: 0, height: 0 }}>
            {props.children[0]}
          </div>
          {props.children[1]}
        </div>
      </div>
    </Control>
  );

  return (
    <div className={styles.text}>
      <Select
        styles={customStyles}
        classNamePrefix="ProfileDropdown"
        options={options}
        maxMenuHeight="500px"
        openMenuOnFocus
        blurInputOnSelect
        isSearchable={false}
        components={{
          Option: IconOption,
          Control: IconControl,
        }}
      />
    </div>
  );
};

export default ProfileDropdown;
